/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Card } from 'src/components/Card';
import { Icon } from 'src/components/Icon';
import Logo from 'src/assets/images/TrackIn_Logo.svg';
import { useDispatch, useSelector } from 'react-redux';
import * as ActionTypes from 'src/store/actions';
import cx from 'classnames';
import { useLocation, useParams } from 'react-router-dom';
import { history } from 'src/utils/history';
import { groupBy, orderBy, uniqBy } from 'lodash';
import { getPolygons } from 'src/pages/Sandbox/services/api';
import { axiosJsonInstance } from 'src/store/api';
import styles from './styles.module.css';

type IParamsProps = {
  id?: string;
  storeId?: string;
  cameraId?: string;
  areaId?: string
};

const SideMenu: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { cameraId, storeId, areaId } = useParams<IParamsProps>();
  const { areas } = useSelector((state: any) => state.areas);
  const { is_superuser } = useSelector(({ auth }: any) => auth.user);
  const [localMenuData, setLocalMenuData] = useState<any[]>();
  const [polygonAreas, setPolygonAreas] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(
      ActionTypes.getAreas.request({
        areaType: 'DA',
      }),
    );

    const fetchPolygonAreas = async () => {
      try {
        setLoading(true);
        const response = await getPolygons();
        if (response && 'data' in response) {
          const transformedPolygons = response.data.map((item: any) => ({
            id: item.id,
            name: item.name,
            camera: item.camera,
            department: item.department,
            store: item.store,
            isPolygon: true
          }));
          setPolygonAreas(transformedPolygons);
        }
      } catch (error) {
        console.error('Error fetching polygons:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchPolygonAreas();
  }, [dispatch]);

  const handleClickMenu = (storeId: number, department: number, cameraId: number, areaId: number, isPolygon: boolean) => {
    // history.push(`/camera/${storeId}/${department}/${cameraId}/${areaId}`);
    if (isPolygon) {
      history.push(`/polygon/${storeId}/${department}/${cameraId}/${areaId}`);
    } else {
      history.push(`/area/${storeId}/${department}/${cameraId}/${areaId}`);
    }
  };

  useEffect(() => {
    const dwellData = areas.filter((data: any) => data.camera?.store === 3 || data.camera?.store === 4);
    const normalizedPolygonAreas = (polygonAreas || []).map((polygon: any) => {
      const storeId = polygon.store || (polygon.camera && typeof polygon.camera === 'object' ? polygon.camera.store : 3);
      const cameraId = typeof polygon.camera === 'number' ? polygon.camera : (polygon.camera && polygon.camera.id ? polygon.camera.id : 0);
      const departmentId = polygon.department || (polygon.camera && typeof polygon.camera === 'object' ? polygon.camera.department : 1);
      
      return {
        ...polygon,
        camera: {
          id: cameraId,
          store: storeId,
          department: departmentId
        },
        isPolygon: true
      };
    });

    const polygonData = normalizedPolygonAreas.filter((data: any) => data.camera.store === 3 || data.camera.store === 4);

    const mainRestaurantPolygons: any[] = [];
    const mainRestaurantRegular: any[] = [];
    const marketPolygons: any[] = [];
    const marketRegular: any[] = [];

    dwellData.forEach((area: any) => {
      if (area.camera.store === 4) {
        mainRestaurantRegular.push(area);
      } else if (area.camera.store === 3) {
        marketRegular.push(area);
      }
    });

    polygonData.forEach((area: any) => {
      if (area.camera.store === 4) {
        mainRestaurantPolygons.push(area);
      } else if (area.camera.store === 3) {
        marketPolygons.push(area);
      }
    });

    mainRestaurantPolygons.sort((a, b) => a.name.localeCompare(b.name));
    mainRestaurantRegular.sort((a, b) => a.name.localeCompare(b.name));
    marketPolygons.sort((a, b) => a.name.localeCompare(b.name));
    marketRegular.sort((a, b) => a.name.localeCompare(b.name));

    const menu = [
      {
        id: 4,
        name: 'Main Restaurant',
        active: (location.pathname.indexOf('area') > 0 || location.pathname.indexOf('polygon') > 0) && Number(storeId) === 4,
        areas: [
          ...mainRestaurantPolygons.map((area) => ({
            id: area.id,
            name: `${area.name} (cam: ${area.camera.id})`,
            storeId: area.camera.store,
            cameraId: area.camera.id,
            department: area.camera.department,
            active: location.pathname.indexOf('polygon') > 0 && Number(areaId) === area.id,
            isPolygon: true
          })),
          // ...mainRestaurantRegular.map((area) => ({
          //   id: area.id,
          //   name: `${area.name} (cam: ${area.camera.id})`,
          //   storeId: area.camera.store,
          //   cameraId: area.camera.id,
          //   department: area.camera.department,
          //   active: location.pathname.indexOf('area') > 0 && Number(areaId) === area.id,
          //   isPolygon: false
          // })),
        ],
      }, {
        id: 3,
        name: 'Market',
        active: (location.pathname.indexOf('area') > 0 || location.pathname.indexOf('polygon') > 0) && Number(storeId) === 3,
        areas: [
          ...marketPolygons.map((area) => ({
            id: area.id,
            name: `${area.name} (cam: ${area.camera.id})`,
            cameraId: area.camera.id,
            storeId: area.camera.store,
            department: area.camera.department,
            active: location.pathname.indexOf('polygon') > 0 && Number(areaId) === area.id,
            isPolygon: true
          })),
          // ...marketRegular.map((area) => ({
          //   id: area.id,
          //   name: `${area.name} (cam: ${area.camera.id})`,
          //   cameraId: area.camera.id,
          //   storeId: area.camera.store,
          //   department: area.camera.department,
          //   active: location.pathname.indexOf('area') > 0 && Number(areaId) === area.id,
          //   isPolygon: false
          // })),
        ],
      },
    ];

    setLocalMenuData(menu);
  }, [areas, storeId, cameraId, location.pathname, polygonAreas, areaId]);

  return (
    <Card className="md:min-h-[100vh] h-full sticky top-0 left-0 overflow-y-auto">
      <div
        className="w-full mb-5 pt-3 cursor-pointer sticky top-0 left-0 bg-white py-2"
        onClick={() => history.push(is_superuser ? '/super-admin/admin-dashboard' : '/')}
      >
        <img src={Logo} width="74" alt="TrackIn" className="mx-auto" />
      </div>
      <div
        className={cx('p-2 cursor-pointer', {
          'pl-0 border-l-4 border-primary bg-gray-100': location.pathname === '/sky',
        })}
        onClick={() => history.push('/sky')}
      >
        <Icon icon="dashboard" className="mt-1 mx-2" />
        Sky
      </div>
      {/* <div
        className={cx('p-2 cursor-pointer', {
          'pl-0 border-l-4 border-primary bg-gray-100': location.pathname === '/sandbox',
        })}
        onClick={() => history.push('/sandbox')}
      >
        <Icon icon="area" className="mt-1 mx-2" />
        Sandbox
      </div> */}
      {localMenuData &&
        localMenuData.map((store: any) => (
          <div
            key={store.id}
            className={`${styles.menuItem} ${cx('p-2', {
              'pl-0 bg-gray-100': store.active,
            })}`}
          >
            <div
              title={store.name}
              className={`${cx('p-2 flex flex-row pb-0 cursor-default justify-between', {
                'border-primary': store.active,
              })}`}
            >
              <p className="truncate">
                <Icon icon="store" className="mt-1 mr-2" />
                {store.name}
              </p>
              <div>
                <Icon icon="arrow-down" className="mt-2 mr-2 float-right" />
              </div>
            </div>
            <ul
              className={cx(
                `pointer ${store.active ? styles.activeSubmenu : ''}
                }`,
              )}
            >
              {store.areas.map((area: any) => (
                <div
                  title={area.name}
                  key={`${store.id}-${area.id}-${area.isPolygon ? 'polygon' : 'camera'}`}
                  className={`flex h-10 text-gray-600 hover:bg-primary-dark/30 ${area.active ? 'border-l-4 border-primary' : ''} ${area.isPolygon ? 'bg-blue-50' : ''}`}
                  onClick={() => handleClickMenu(area.storeId, area.department, area.cameraId, area.id, area.isPolygon)}
                >
                  <div className="ml-2 self-center">
                    <Icon icon={area.isPolygon ? 'area' : 'cameraVideo'} />
                  </div>
                  <div className="truncate">
                    {area.name}
                  </div>
                </div>
              ))}
            </ul>
          </div>
        ))}
    </Card>
  );
};
export default SideMenu;
